import { render, staticRenderFns } from "./StakingUpdate.vue?vue&type=template&id=7b71f3ca"
import script from "./StakingUpdate.vue?vue&type=script&lang=ts"
export * from "./StakingUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports